<!-- ----------------------------------------------- -->
<template>
  <transition name="modal" appear>
    <div class="com-modal com-modal-overlay" @click.self="$emit('close')">
      <v-card class="com-pc-card tm-pcfull-detail-past">
        <v-row class="com-pc-card-header">
          <span class="com-pc-card-title pb-4">{{ text.title }}</span>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" width="600px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                outlined
                x-small
                class="mb-4"
                color="white"
                v-clipboard:copy="copyValues"
                v-bind="attrs"
                v-on="on"
              >
                <span>{{ text.copy }}</span>
              </v-btn>
            </template>
            <v-card>
              <v-card-title class="tm-pcfull-detail-copy-dialog">
                <span class="message">{{ text.dialogMessage }}</span>
              </v-card-title>
            </v-card>
          </v-dialog>
          <div>
            <v-btn
              outlined
              x-small
              class="mb-4 ml-2"
              color="white"
              @click="print"
            >
              <span>{{ text.print }}</span>
            </v-btn>
          </div>
          <div v-show="showQwtrDbBtn()" class="pb-4">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  outlined
                  x-small
                  class="ml-2 mb-1"
                  color="white"
                  v-bind="attrs"
                  v-on="on"
                  @click="openQwtrDb()"
                >
                  <span>{{ text.qwtrDbObs }}</span>
                </v-btn>
              </template>
              <span>{{ text.qwtrDbMsg }}</span>
            </v-tooltip>
          </div>
          <v-btn text icon color="white" @click="$emit('close')" class="pb-4">
            <v-icon>highlight_off</v-icon>
          </v-btn>
        </v-row>
        <v-row class="com-pc-card-contents ma-0">
          <v-col class="scroll">
            <v-simple-table class="table">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th
                      v-for="title in headers1"
                      :key="title.key"
                      nowrap
                      :colspan="title.col"
                      class="head-item"
                      :class="title.cls"
                    >
                      {{ title.text }}
                    </th>
                  </tr>
                  <tr>
                    <th
                      v-for="title in headers2"
                      :key="title.key"
                      nowrap
                      :rowspan="title.row"
                      :colspan="title.col"
                      class="head-item  px-1"
                      :class="title.cls"
                    >
                      {{ title.text }}
                    </th>
                  </tr>
                  <tr>
                    <th
                      v-for="title in headers3"
                      :key="title.key"
                      class="head-item"
                      :class="title.cls"
                    >
                      {{ title.text }}
                    </th>
                  </tr>
                </thead>
                <tbody v-show="!loading">
                  <tr v-for="time of 24" :key="time">
                    <td
                      v-for="item of items(time)"
                      :key="item.key"
                      :class="item.cls"
                    >
                  <sapn
                    v-if="showCoastHighlight(item.cd)"
                    class="tm-pc-detail-coast-ovlvl-color-highlight"
                    :rw-info-color="setInfoColor(item.cd)"
                  >
                    {{ item.text }}
                  </sapn>
                  <sapn v-else>
                    {{ item.text }}
                  </sapn>

                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
          <v-row
            v-show="loading"
            align="center"
            justify="center"
            class="progress"
          >
            <v-progress-circular
              indeterminate
              :size="100"
              :width="10"
              justify-center
            ></v-progress-circular>
          </v-row>
        </v-row>
      </v-card>
    </div>
  </transition>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 海岸観測所詳細 過去データ表示
 * TmCoastDetailPast.vue
 * @author LIS
 */
import util from "./../../../lib/util";
import tmObs from "./../../../lib/tmObs";

export default {
  name: "tm-coast-detail-past",
  data() {
    return {
      text: {
        title: "過去一週間のデータ",
        other: "--",
        header1: "日付",
        header2: "観測項目",
        onth: "1/3有義波",
        wind: "平均",
        hght: "波高\r\n[m]",
        cycl: "周期\r\n[s]",
        tide: "潮位\r\n[T.P.m]",
        dir: "風向",
        spd: "風速\r\n[m/s]",
        qwtrDbObs: "水文水質観測所情報",
        qwtrDbStgRk: "水文水質観測所水位ランキング",
        qwtrDbMsg:
          "さらに過去のデータをご覧になりたい場合は、このボタンのリンク先をご利用ください",
        copy: "コピー",
        dialogMessage: "コピーしました。",
        print: "印刷",
      },
      yesterday: util.toDate(),
      dialog: false,
    };
  },
  created() {
    this.$log.debug("[TmCoastDetailPast] created()");
    this.yesterday = util.formatDate(
      util.subDays(this.appTime, 1),
      "YYYY-MM-DD"
    );

    this.$store.dispatch("Telemeter/getSelectedTmCoastPast", {
      date: this.appTime,
    });
  },
  computed: {
    appTime: {
      get() {
        return this.$store.state.app.appTime;
      },
    },
    headers1: {
      get() {
        let header = [
          { text: this.text.header1, key: "title", col: 1, cls: "top" },
        ];
        for (let day = 6; day >= 0; day--) {
          let title = util.formatDate(
            util.subDays(this.yesterday, day),
            "MM/DD"
          );
          let head = {
            text: title,
            key: "day" + day,
            col: 5,
            cls: "first",
          };
          header.push(head);
        }
        return header;
      },
    },
    headers2: {
      get() {
        let header = [
          {
            text: this.text.header2,
            key: "obs",
            row: 2,
            col: 1,
            cls: "top-2nd",
          },
        ];
        for (let day = 6; day >= 0; day--) {
          let head = {
            text: this.text.onth,
            key: "onth" + day,
            row: 1,
            col: 2,
            cls: "second",
          };
          header.push(head);
          head = {
            text: this.text.tide,
            key: "tide" + day,
            row: 2,
            col: 1,
            cls: "second",
          };
          header.push(head);
          head = {
            text: this.text.wind,
            key: "wind" + day,
            row: 1,
            col: 2,
            cls: "second",
          };
          header.push(head);
        }
        return header;
      },
    },
    headers3: {
      get() {
        let header = [];
        for (let day = 6; day >= 0; day--) {
          let head = {
            text: this.text.hght,
            key: "hght" + day,
            cls: "third",
          };
          header.push(head);
          head = {
            text: this.text.cycl,
            key: "cycl" + day,
            cls: "third",
          };
          header.push(head);
          head = {
            text: this.text.dir,
            key: "dir" + day,
            cls: "third",
          };
          header.push(head);
          head = {
            text: this.text.spd,
            key: "spd" + day,
            cls: "third",
          };
          header.push(head);
        }
        return header;
      },
    },

    loading: {
      get() {
        return this.$store.state.Telemeter.selectedTmPast == null;
      },
    },
    qwtrDb: {
      get() {
        return {
          qwtrObsCd: this.$store.state.Telemeter.selectedTm.tmCoastDetailInfo
            .qwtrObsCd,
          dbLink: this.$store.state.Telemeter.selectedTm.tmCoastDetailInfo
            .dbLink,
        };
      },
    },
    copyValues: {
      get() {
        const pastList = this.$store.state.Telemeter.selectedTmPast;
        let resultList = [];
        let copyheaders3 = [];
        let cnt = 2;
        for (var i = 0; i < this.headers3.length; i++) {
          if (i == 0) {
            let head = {
              text: this.text.header2,
            };
            copyheaders3.push(head);
          }
          if (cnt == 4) {
            let head = {
              text: this.text.tide,
            };
            copyheaders3.push(head);
            cnt = 0;
          }
          copyheaders3.push(this.headers3[i]);
          cnt++;
        }

        resultList.push(tmObs.getCopyHeader(this.headers1, 5));
        resultList.push(tmObs.getCopyHeader(this.headers2, 2, 1, 2));
        resultList.push(tmObs.getCopyHeader(copyheaders3));
        for (let hour = 1; hour <= 24; hour++) {
          let time = util.formatDate(util.toDate().setHours(hour), "HH:00");
          if (time == "00:00") {
            time = "24:00";
          }
          let item = time + "\t";
          if (null != pastList && Object.keys(pastList).length > 0) {
            for (let day = 6; day >= 0; day--) {
              let date = util.formatDate(
                util.subDays(this.yesterday, day),
                "YYYY/MM/DD"
              );
              let onthwvHght = this.text.other;
              let onthwvCycl = this.text.other;
              let tide = this.text.other;
              let windSpd = this.text.other;
              let windDir = this.text.other;
              let key = date + time;
              if (key in pastList) {
                onthwvHght = tmObs.checkCcd(
                  pastList[key].onthwvHght,
                  pastList[key].onthwvHghtCcd,
                  2
                );
                onthwvCycl = tmObs.checkCcd(
                  pastList[key].onthwvCycl,
                  pastList[key].onthwvCyclCcd,
                  1
                );
                tide = tmObs.checkCcd(
                  pastList[key].tide,
                  pastList[key].tideCcd,
                  2
                );
                windDir = tmObs.formatWndDir(
                  tmObs.checkCcd(
                    pastList[key].windDir,
                    pastList[key].windDirCcd
                  )
                );
                windSpd = tmObs.checkCcd(
                  pastList[key].windSpd,
                  pastList[key].windSpdCcd,
                  1
                );
              }
              item +=
                onthwvHght +
                "\t" +
                onthwvCycl +
                "\t" +
                tide +
                "\t" +
                windDir +
                "\t" +
                windSpd +
                (day != 0 ? "\t" : "");
            }
          } else {
            // 過去一週間の情報が取得出来なかった場合
            for (let day = 6; day >= 0; day--) {
              item +=
                this.text.other +
                "\t" +
                this.text.other +
                "\t" +
                this.text.other +
                "\t" +
                this.text.other +
                "\t" +
                this.text.other +
                (day != 0 ? "\t" : "");
            }
          }
          resultList.push(item);
        }
        return resultList.join("\n");
      },
    },
  },
  watch: {
    dialog() {
      // 指定秒後ダイアログを閉じる
      setTimeout(() => {
        this.dialog = false;
      }, 1000);
      // 指定秒後ボタンのfocusを解除する
      setTimeout(() => {
        const elem = document.activeElement;
        elem.blur();
      }, 1200);
    },
  },
  methods: {
    items(val) {
      let time = util.formatDate(util.toDate().setHours(val), "HH:00");
      if (time == "00:00") {
        time = "24:00";
      }
      let item = [{ text: time, key: time, cls: "subhead" }];
      const pastList = this.$store.state.Telemeter.selectedTmPast;
      if (null != pastList && Object.keys(pastList).length > 0) {
        for (let day = 6; day >= 0; day--) {
          let date = util.formatDate(
            util.subDays(this.yesterday, day),
            "YYYY/MM/DD"
          );
          let onthwvHght = this.text.other;
          let onthwvCycl = this.text.other;
          let tide = this.text.other;
          let windSpd = this.text.other;
          let windDir = this.text.other;
          let onthwvHghtovcutwarn = 0;
          let tidlvlovcutwarn = 0;
          let avewndspdovcutwarn = 0;
          let key = date + time;
          if (key in pastList) {
            onthwvHght = tmObs.checkCcd(
              pastList[key].onthwvHght,
              pastList[key].onthwvHghtCcd,
              2
            );
            if (pastList[key].onthwvHghtWarnOvflg === 1) {
              onthwvHghtovcutwarn = 2;
            } else if (pastList[key].onthwvHghtCautOvflg === 1) {
              onthwvHghtovcutwarn = 1;
            }
            onthwvCycl = tmObs.checkCcd(
              pastList[key].onthwvCycl,
              pastList[key].onthwvCyclCcd,
              1
            );
            tide = tmObs.checkCcd(pastList[key].tide, pastList[key].tideCcd, 2);
            if (pastList[key].tidlvlWarnOvflg === 1) {
              tidlvlovcutwarn = 2;
            } else if (pastList[key].tidlvlCautOvflg === 1) {
              tidlvlovcutwarn = 1;
            }
            windDir = tmObs.formatWndDir(
              tmObs.checkCcd(pastList[key].windDir, pastList[key].windDirCcd)
            );
            windSpd = tmObs.checkCcd(
              pastList[key].windSpd,
              pastList[key].windSpdCcd,
              1
            );
            if (pastList[key].avewndSpdWarnOvflg === 1) {
              avewndspdovcutwarn = 2;
            } else if (pastList[key].avewndSpdCautOvflg === 1) {
              avewndspdovcutwarn = 1;
            }
}
          let body = {
            text: onthwvHght,
            key: date + time + "onthwvHght",
            cls: "body",
            cd: onthwvHghtovcutwarn,
          };
          item.push(body);
          body = {
            text: onthwvCycl,
            key: date + time + "onthwvCycl",
            cls: "body",
          };
          item.push(body);
          body = {
            text: tide,
            key: date + time + "tide",
            cls: "body",
            cd: tidlvlovcutwarn,
          };
          item.push(body);
          body = {
            text: windDir,
            key: date + time + "windDir",
            cls: "body",
          };
          item.push(body);
          body = {
            text: windSpd,
            key: date + time + "windSpd",
            cls: "body",
            cd: avewndspdovcutwarn,
          };
          item.push(body);
        }
      } else {
        // 過去一週間の情報が取得出来なかった場合
        for (let day = 6; day >= 0; day--) {
          let date = util.formatDate(
            util.subDays(this.yesterday, day),
            "YYYY/MM/DD"
          );
          let onthwvHght = this.text.other;
          let onthwvCycl = this.text.other;
          let tide = this.text.other;
          let windSpd = this.text.other;
          let windDir = this.text.other;

          let body = {
            text: onthwvHght,
            key: date + time + "onthwvHght",
            cls: "body",
          };
          item.push(body);
          body = {
            text: onthwvCycl,
            key: date + time + "onthwvCycl",
            cls: "body",
          };
          item.push(body);
          body = {
            text: tide,
            key: date + time + "tide",
            cls: "body",
          };
          item.push(body);
          body = {
            text: windDir,
            key: date + time + "windDir",
            cls: "body",
          };
          item.push(body);
          body = {
            text: windSpd,
            key: date + time + "windSpd",
            cls: "body",
          };
          item.push(body);
        }
      }
      return item;
    },
    showQwtrDbBtn() {
      if (
        this.qwtrDb.qwtrObsCd !== null &&
        this.qwtrDb.qwtrObsCd !== undefined &&
        this.qwtrDb.dbLink === 1
      ) {
        return true;
      } else {
        return false;
      }
    },
    openQwtrDb() {
      let link =
        this.$store.state.app.config.appConfig.linkUrls.qwtrDbLink +
        this.qwtrDb.qwtrObsCd;
      window.open(link);
    },
    print() {
      if (!this.$store.state.app.isCurrent) {
        let routeData = this.$router.resolve({
          name: "printPreview",
          query: {
            itmkndCd: this.$route.query.itmkndCd,
            ofcCd: this.$route.query.ofcCd,
            obsCd: this.$route.query.obsCd,
            appTime: util.formatDate(
              this.$store.state.app.appTime,
              "YYYY-MM-DD HH:mm"
            ),
            isCurrent: this.$store.state.app.isCurrent,
            fld: this.$route.query.fld,
            type: "past",
          },
        });
        window.open(
          routeData.href,
          "",
          "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0"
        );
      } else {
        let routeData = this.$router.resolve({
          name: "printPreview",
          query: {
            itmkndCd: this.$route.query.itmkndCd,
            ofcCd: this.$route.query.ofcCd,
            obsCd: this.$route.query.obsCd,
            isCurrent: this.$store.state.app.isCurrent,
            fld: this.$route.query.fld,
            type: "past",
          },
        });
        window.open(
          routeData.href,
          "",
          "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0"
        );
      }
    },
    /**
     * 超過観測所 着色
     */
    setInfoColor(cd) {
        if (cd === 2 ) {
          return "danger";
        } else if (cd === 1) {
          return "refuge";
        }
    },

    /** 超過の強調表示をするか */
    showCoastHighlight(cd) {
        if (cd === 1 || cd === 2) {
          return true;
        }
        return false;
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped></style>
